import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AngularLocationSelectorComponent } from './angular-location-selector.component';
import { LocationMultiSelectorModule } from './location-multi-selector/location-multi-selector-module';
import { LocationSingleSelectorModule } from './location-single-selector/location-single-selector-module';

@NgModule({
  declarations: [AngularLocationSelectorComponent],
  imports: [
    LocationSingleSelectorModule,
    LocationMultiSelectorModule,
    CommonModule
  ],
  exports: [AngularLocationSelectorComponent]
})
export class AngularLocationSelectorModule { }
